import RestaurantDetails from "view3/RestaurantDetails.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    alert: state.alert,
    attributes: state.attributes,
    user: state.user,
    location: state.location
  };
}

const RestaurantDetailsContainer = connectFunction(mapStateToProps)(
  RestaurantDetails
);
export default RestaurantDetailsContainer;
